/** smooth-scroll v5.1.4, by Chris Ferdinandi | http://github.com/cferdinandi/smooth-scroll | Licensed under MIT: http://gomakethings.com/mit/ */
!function(t,e){"function"==typeof define&&define.amd?define("smoothScroll",e(t)):"object"==typeof exports?module.exports=e(t):t.smoothScroll=e(t)}(window||this,function(t){"use strict";var e,n={},o=!!document.querySelector&&!!t.addEventListener,r={speed:500,easing:"easeInOutCubic",offset:0,updateURL:!0,callbackBefore:function(){},callbackAfter:function(){}},a=function(t,e,n){if("[object Object]"===Object.prototype.toString.call(t))for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&e.call(n,t[o],o,t);else for(var r=0,a=t.length;a>r;r++)e.call(n,t[r],r,t)},c=function(t,e){var n={};return a(t,function(e,o){n[o]=t[o]}),a(e,function(t,o){n[o]=e[o]}),n},u=function(t,e){for(var n=e.charAt(0);t&&t!==document;t=t.parentNode)if("."===n){if(t.classList.contains(e.substr(1)))return t}else if("#"===n){if(t.id===e.substr(1))return t}else if("["===n&&t.hasAttribute(e.substr(1,e.length-2)))return t;return!1},i=function(t){for(var e,n=String(t),o=n.length,r=-1,a="",c=n.charCodeAt(0);++r<o;){if(e=n.charCodeAt(r),0===e)throw new InvalidCharacterError("Invalid character: the input contains U+0000.");a+=e>=1&&31>=e||127==e||0===r&&e>=48&&57>=e||1===r&&e>=48&&57>=e&&45===c?"\\"+e.toString(16)+" ":e>=128||45===e||95===e||e>=48&&57>=e||e>=65&&90>=e||e>=97&&122>=e?n.charAt(r):"\\"+n.charAt(r)}return a},s=function(t,e){var n;return"easeInQuad"===t&&(n=e*e),"easeOutQuad"===t&&(n=e*(2-e)),"easeInOutQuad"===t&&(n=.5>e?2*e*e:-1+(4-2*e)*e),"easeInCubic"===t&&(n=e*e*e),"easeOutCubic"===t&&(n=--e*e*e+1),"easeInOutCubic"===t&&(n=.5>e?4*e*e*e:(e-1)*(2*e-2)*(2*e-2)+1),"easeInQuart"===t&&(n=e*e*e*e),"easeOutQuart"===t&&(n=1- --e*e*e*e),"easeInOutQuart"===t&&(n=.5>e?8*e*e*e*e:1-8*--e*e*e*e),"easeInQuint"===t&&(n=e*e*e*e*e),"easeOutQuint"===t&&(n=1+--e*e*e*e*e),"easeInOutQuint"===t&&(n=.5>e?16*e*e*e*e*e:1+16*--e*e*e*e*e),n||e},f=function(t,e,n){var o=0;if(t.offsetParent)do o+=t.offsetTop,t=t.offsetParent;while(t);return o=o-e-n,o>=0?o:0},l=function(){return Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.body.clientHeight,document.documentElement.clientHeight)},d=function(t){return t&&"object"==typeof JSON&&"function"==typeof JSON.parse?JSON.parse(t):{}},h=function(t,e){history.pushState&&(e||"true"===e)&&history.pushState({pos:t.id},"",window.location.pathname+t)};n.animateScroll=function(e,n,o){var a=c(a||r,o||{}),u=d(e?e.getAttribute("data-options"):null);a=c(a,u),n="#"+i(n.substr(1));var p,m,b,v=document.querySelector("[data-scroll-header]"),g=null===v?0:v.offsetHeight+v.offsetTop,O=t.pageYOffset,y=f(document.querySelector(n),g,parseInt(a.offset,10)),I=y-O,S=l(),w=0;h(n,a.updateURL);var A=function(o,r,c){var u=t.pageYOffset;(o==r||u==r||t.innerHeight+u>=S)&&(clearInterval(c),a.callbackAfter(e,n))},Q=function(){w+=16,m=w/parseInt(a.speed,10),m=m>1?1:m,b=O+I*s(a.easing,m),t.scrollTo(0,Math.floor(b)),A(b,y,p)},C=function(){a.callbackBefore(e,n),p=setInterval(Q,16)};0===t.pageYOffset&&t.scrollTo(0,0),C()};var p=function(t){var o=u(t.target,"[data-scroll]");o&&"a"===o.tagName.toLowerCase()&&(t.preventDefault(),n.animateScroll(o,o.hash,e,t))};return n.destroy=function(){e&&(document.removeEventListener("click",p,!1),e=null)},n.init=function(t){o&&(n.destroy(),e=c(r,t||{}),document.addEventListener("click",p,!1))},n});

$(function() {

  // ---------------------------------------------
  // FIXED HEADER
  // ---------------------------------------------

  var sticky_header = function(){

    var target = $('header'),
        targetHeight = target.innerHeight(),
        body = $('body');

         $(window).scroll(function(){
                if( $(window).scrollTop() > targetHeight ) {
                        target.removeClass('dark').addClass('fixed');
                        body.css('padding-top', targetHeight);
                } else {
                        target.removeClass('fixed').addClass('dark');
                        body.css('padding-top', 0);
                }
        });

  }

if (!$('body').hasClass('fixed-header')) {
  sticky_header();
}

  /*if (!$('body').hasClass('fixed-header')) {
    var originalHeader = $('header:first');
    originalHeader.after($(originalHeader[0].outerHTML));

    var fixedHeader = $('header:last');
    var headerHeight = fixedHeader.height();
    fixedHeader.removeClass('dark').addClass('fixed');
    fixedHeader.css({ "top": "-"+(headerHeight + 1)+"px" });

    var previousScrollOffset = 0;
    var menuIsHidden = true;

    $(window).scroll(function() {
      var currentScrollOffset = $(window).scrollTop();

      if (previousScrollOffset < currentScrollOffset) {
        if (menuIsHidden && currentScrollOffset >= headerHeight) {
          menuIsHidden = false;
          fixedHeader.animate({ "top": "0" }, 400);
        }
      }
      else {
        if (!menuIsHidden && currentScrollOffset < headerHeight) {
          menuIsHidden = true;
          fixedHeader.animate({ "top": "-"+(headerHeight + 1)+"px" }, 400);
        }
      }

      previousScrollOffset = currentScrollOffset;
    });
  }*/

  // ---------------------------------------------
  // FORMS
  // ---------------------------------------------

  $('a.checkbox').click(function() {
    $(this).siblings('.checkbox').removeClass('checked');
    $(this).addClass('checked');

    // First we set the new image from the product ID.
    var product_id = $(this).attr('data-id');
    $('#product-id').val(product_id);
    $('.product-image img').addClass('hidden');
    $('#product-image-' + product_id).removeClass('hidden');

    //$('.subscription').addClass('hidden');
    $('#subscription-' + product_id).removeClass('hidden');

    $('.product_description').addClass('hidden');
    $('#product_description-' + product_id).removeClass('hidden');

    $('#subscription-' + product_id).find('.sub_checkbox').removeClass('checked');
    $('#subscription-' + product_id).find('.sub_checkbox').eq(0).addClass('checked');

    var price = $('#subscription-' + product_id).find('.sub_checkbox').eq(0).attr('price');
    $('#total_cost').text(price);

    // Then we set the product ID to the variants ID.
    product_id = $('#subscription-' + product_id).find('.sub_checkbox').eq(0).attr('data-id');
    $('#product-id').val(product_id);

    return false;
  });

  $('a.sub_checkbox').click(function() {
    $('.sub_checkbox').removeClass('checked');
    $(this).addClass('checked');

    var product_id = $(this).attr('data-id');
    $('#product-id').val(product_id);

    var price = $(this).attr('price');
    $('#total_cost').text(price);

    return false;
  });

  // ---------------------------------------------
  // PRODUCT PAGE TABS
  // ---------------------------------------------

  $('.tabs a').click(function() {
  	var link = $(this);
    var li = link.parent('li');

    li.siblings('li').removeClass('active');
    li.addClass('active');

    $('section.active').removeClass('active').fadeOut(200, function() {
      $('#section-' + link.attr('href').substring(1)).addClass('active').fadeIn(200);
    });
  });

  if (window.location.hash && $('#section-' + window.location.hash.substring(1)).length) {
    $('.tabs a[href="' + window.location.hash + '"]').trigger('click');
  }

  // ---------------------------------------------
  // Collapsible Panel
  // ---------------------------------------------

  $('.panel-header').click(function(){
    var trigger = $(this),
        target = trigger.next(),
        all_siblings = trigger.parent().find('.panel-header'),
        all_targets = trigger.parent().find('.panel-content');

        if( !trigger.hasClass('active') ) {

            // Reset Panels
           all_siblings.removeClass('active');
            all_targets.slideUp();

            // Active This Panel
            target.slideDown("slow", function(){
              $('html, body').animate({
                scrollTop: trigger.offset().top - 65
              }, 500);

            });

            trigger.addClass('active');
        } else {

          // Reset Panels

          target.slideUp();
          trigger.removeClass('active');
            
           all_targets.slideUp();
           all_siblings.removeClass('active');

             $('html, body').animate({
                scrollTop: trigger.offset().top - 65
              }, 500);

        }

        return false;

  });

  // ---------------------------------------------
  // IMAGE CAROUSELS
  // ---------------------------------------------

  $('#sample-thumbs a').click(function() {
    $(this).siblings('a').removeClass('active');
    $(this).addClass('active');

    $('#large-sample > img').removeClass('active');
    $('#large-sample > img' + $(this).attr('href')).addClass('active');

    $('#sample-description').text($(this).attr('data-text'));

    return false;
  });

  // ---------------------------------------------
  // TESTIMONIES
  // ---------------------------------------------

  /*$('#testimony-tabs a').click(function() {
  	$(this).siblings('a').removeClass('active');
    $(this).addClass('active');

    $('#large-testimony div').removeClass('active');
    $($(this).attr('href')).addClass('active');

    $('#large-testimony-arrow').animate({ 'left': $(this).attr('data-arrow-pos') + 'px' }, 200);

    return false;
  });*/

  // ---------------------------------------------
  // FAQs
  // ---------------------------------------------

  $('.faq .list a').click(function() {
    $('.faq .list .active').removeClass('active');
    $('.answers .active').removeClass('active');
    $(this).addClass('active');
    $($(this).attr('href')).addClass('active');

    return false;
  });

  // ------------------------------------------------------
  // Product price picker
  // ------------------------------------------------------

  $('#product-variant-id').change(function() {
    var price = $('#product-variant-id option:selected:first').attr('data-price');
    $('#buy .price').text(price);
  });

});


$(function() {
  $('#read_more_button').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
});



// ------------------------------------------------------
// Flexslider: for different kind of slider
// ------------------------------------------------------
function run_sliders(){
  var testi_tab_width = 220,
      tab_max_item = 0,
      animation_type = "slide";

  // Change the value if the viewport is smaller then 768px (mobile)
  if (Modernizr.mq("screen and (max-width:767px)")) {
      testi_tab_width = 100;
      animation_type = "fade";
  }

  $('#large-testimony').flexslider({
    animation: "slide",
    directionNav: false,
    controlNav: false,
    slideshow: false,
    animationLoop: false,
    smoothHeight: true,
    sync: "#testimony-tabs"
  });

$('#testimony-tabs').flexslider({
    animation: "slide",
    directionNav: false,
    controlNav: false,
    slideshow: false,
    animationLoop: false,
    itemWidth: testi_tab_width,
    move: 1,
    itemMargin: 0,
    maxItems: tab_max_item,
    asNavFor: "#large-testimony"
  });

  // Slider only executed if the view port is smaller then 768px (mobile)
  if (Modernizr.mq("screen and (max-width:767px)")) {
      
    $('.camera-usp').flexslider({
        animation: "slide",
        directionNav: false,
        animationLoop: false,
        slideshow: false
      });

      /* User Testimonial */

      $('#user-testimonies').flexslider({
        animation: "slide",
        directionNav: false,
        controlNav: false,
        slideshow: false,
        animationLoop: false,
        smoothHeight: true,
        sync: "#user-avatar"
      });

      $('#user-avatar').flexslider({
        animation: "slide",
        directionNav: false,
        controlNav: false,
        slideshow: false,
        animationLoop: false,
        itemWidth: testi_tab_width,
        move: 1,
        itemMargin: 0,
        asNavFor: "#user-testimonies"
      });
  }

}

$(window).load(function() {

// ------------------------------------------------------
// Toggle Nav
// ------------------------------------------------------
  
  $('.toggle-nav').click( function(){
    var body = $('body');
    
    if( !body.hasClass('nav-expanded') ) {
        body.addClass('nav-expanded');
    } else {
      body.removeClass('nav-expanded');
    }

    return false;
  });

   $('#close-mnav').click( function(){
    var body = $('body');

    if( body.hasClass('nav-expanded') ) {
        body.removeClass('nav-expanded');
    }

    return false;
  });

  // Run sliders  
  run_sliders();
  
});

$( window ).resize(function() {
  // Run function on resize but after 1 second only
  setTimeout( function(){
    run_sliders();
  }, 1000);
  
});

 $( document ).ready(function() {
    $("#subscriptionlink").click(function() {  
		$('.tabs a[href="#subscription"]').trigger('click');
      	smoothScroll.animateScroll( null, '#infoscroll' );
    });
 });